/* this file added by Bearer Web Developer  */
const getDate = (miliseconds?: number | null): string => {
    // Get the current date
    const date = miliseconds ? new Date(miliseconds) : new Date();
    // Extract year, month, and day
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export default getDate;